import React, { useState } from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import { makeStyles, useTheme } from '@material-ui/styles';
import { useMediaQuery } from '@material-ui/core';
import ENUMS from '../../configs/enums';

import { Sidebar, Footer, Topbar } from './components';
import { useSelector } from 'react-redux';
// import { TopBarElem } from '../../containers/Bars'

const useStyles = makeStyles(theme => ({
  root: {
    backgroundColor: 'white',
    paddingTop: 56,
    height: '100%',
    display: 'flex',
    flexDirection: 'column',
    minHeight: '90%',
    [theme.breakpoints.down('sm')]: {
      paddingTop: 74
    },
    fontFamily: '"Lato", sans-serif'
  },
  shiftContent: {
    paddingLeft: 240
  },
  content: {
    flex: 1,
    marginTop: "10%",
    '&.tabsOn': {
      marginTop: "23%"
    }
  }
}));

const Main = props => {
  const { children } = props;

  const classes = useStyles();
  const theme = useTheme();
  const roleId = useSelector(state => state.authData.subTypeId);
  const tabsOn = roleId !== ENUMS.roleIds.shop;

  const isDesktop = useMediaQuery(theme.breakpoints.up('lg'), {
    defaultMatches: true
  });

  const [openSidebar, setOpenSidebar] = useState(false);

  const handleSidebarOpen = () => {
    setOpenSidebar(true);
  };

  const handleSidebarClose = () => {
    setOpenSidebar(false);
  };

  const shouldOpenSidebar = isDesktop ? true : openSidebar;

  return (
    <div
      className={clsx({
        [classes.root]: true,
        [classes.shiftContent]: isDesktop
      })}
    >
      <Topbar onSidebarOpen={handleSidebarOpen} />
      <Sidebar
        onClose={handleSidebarClose}
        open={shouldOpenSidebar}
        variant={isDesktop ? 'persistent' : 'temporary'}
      />
      <main
        className={clsx({
          [classes.content]: true,
          [`tabsOn`]: tabsOn
        })}
      >
        {children}
      </main>
        {/* <Footer /> */}
    </div>
  );
};

Main.propTypes = {
  children: PropTypes.node
};

export default Main;
